import { multipleChangingPrio } from './prioNested'
import { formatScorecardDecimal } from 'helpers/scorecardFormat'

export const handleSectionPriority = async (allSectionDetails: any) => {
  try {
    const sectionPrio: string[] = [
      'Subject Expertise (SE)',
      'Subject Pedagogical Content Knowledge',
      'General Pedagogy (GP)',
      'Professional and core competencies (PC)',
    ]
    const bloomsPrio: string[] = ['Knowledge', 'Understanding', 'Application']
    const nationalAvergeSectionWise = allSectionDetails?.national_average_details?.sectionWiseNationalAverage
    const reportThemeSectionWise = allSectionDetails.section_wise_report_theme_details

    //updating section details with section priority
    if (allSectionDetails.section_level_details) {
      const allSectionName = allSectionDetails.section_level_details.labelsOfSection
      const allSectionTotals = allSectionDetails.section_level_details.sectionWiseTotal
      const allSectionPercentages = allSectionDetails.section_level_details.sectionWisePercentage
      const allSectionObtained = allSectionDetails.section_level_details.sectionWiseTotalObtained
      const allBloomLevelSection = allSectionDetails.blooms_level_details?.labelsOfSection
      const allBloomLevelTotal = allSectionDetails.blooms_level_details?.sectionWiseTotal
      const allBloomLevelObtained = allSectionDetails.blooms_level_details?.sectionWiseTotalObtained

      const allSectionWiseDetails = await multipleChangingPrio(sectionPrio, {
        allSectionName,
        allSectionTotals,
        allSectionPercentages,
        allSectionObtained,
      })
      if (allSectionWiseDetails) {
        const newSectionOrder = allSectionWiseDetails.newSectionOrder

        const sectionWiseNaionalAverage = nationalAvergeSectionWise
          ? newSectionOrder.map((item: any) => {
              const nationalAverageIndex = nationalAvergeSectionWise.findIndex((naAvg: any) => naAvg.name === item)
              if (nationalAverageIndex !== -1) {
                return Number(formatScorecardDecimal(nationalAvergeSectionWise[nationalAverageIndex].sectional_national_average))
              }
              return null
            })
          : undefined

        //---prioritizing report theme
        //finding prioritized Items
        const prioritizedRTDetails = reportThemeSectionWise
          ? newSectionOrder
              .map((item: any) => {
                const rTIndex = reportThemeSectionWise.findIndex((rt: any) => rt.section_name === item)
                if (rTIndex !== -1) {
                  return reportThemeSectionWise[rTIndex]
                }
                return null
              })
              .filter(Boolean)
          : []
        //checking non-proritized Report Theme items
        if (reportThemeSectionWise) {
          reportThemeSectionWise.forEach((rt: any) => {
            if (!prioritizedRTDetails.includes(rt)) {
              prioritizedRTDetails.push(rt)
            }
          })
        }

        //prioritizing bloom
        const bloomDetailsRes = await multipleChangingPrio(bloomsPrio, {
          allSectionName: allBloomLevelSection,
          allSectionTotals: allBloomLevelTotal,
          allSectionObtained: allBloomLevelObtained,
        })

        allSectionDetails.section_level_details.labelsOfSection = newSectionOrder ?? allSectionDetails.section_level_details.labelsOfSection
        allSectionDetails.section_level_details.sectionWiseTotal =
          allSectionWiseDetails.newSectionTotal ?? allSectionDetails.section_level_details.sectionWiseTotal
        allSectionDetails.section_level_details.sectionWisePercentage =
          allSectionWiseDetails.newSectionPercentage ?? allSectionDetails.section_level_details.sectionWisePercentage
        allSectionDetails.section_level_details.sectionWiseTotalObtained =
          allSectionWiseDetails.newSectionObtained ?? allSectionDetails.section_level_details.sectionWiseTotalObtained
        allSectionDetails.section_level_details.sectionWiseNationalAverage =
          sectionWiseNaionalAverage ?? allSectionDetails.section_level_details.sectionWiseNationalAverage
        allSectionDetails.section_wise_report_theme_details = prioritizedRTDetails ?? allSectionDetails.section_wise_report_theme_details
        allSectionDetails.blooms_level_details.labelsOfSection = bloomDetailsRes
          ? bloomDetailsRes.newSectionOrder
          : allSectionDetails.blooms_level_details.labelsOfSection
        allSectionDetails.blooms_level_details.sectionWiseTotal = bloomDetailsRes
          ? bloomDetailsRes.newSectionTotal
          : allSectionDetails.blooms_level_details.sectionWiseTotal
        allSectionDetails.blooms_level_details.sectionWiseTotalObtained = bloomDetailsRes
          ? bloomDetailsRes.newSectionObtained
          : allSectionDetails.blooms_level_details.sectionWiseTotalObtained
      }
    }

    return true
  } catch (err) {
    console.error(err, 'something went wrong')
  }
}
